import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ConfigurableDate} from './configurable-date.model';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AuthService} from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurableDateService {

  constructor(private httpClient: HttpClient, private authService: AuthService) {
  }

  configurableDates(): Observable<Array<ConfigurableDate>> {
    return this.httpClient.get<Array<ConfigurableDate>>(`${environment.baseUrl}/configurableDates`, {headers: this.authService.getHeaders()});
  }

  save(configurableDates: Array<ConfigurableDate>): Observable<Array<ConfigurableDate>> {
    return this.httpClient.post<Array<ConfigurableDate>>(`${environment.baseUrl}/admin/configurableDates`, configurableDates, {headers: this.authService.getHeaders()});
  }
}
